import React from 'react'

function TwistOutlet11() {
    return (
        <embed src="\pdfs\E1.1.6.3_DD-VL_Variable_twist_outlet-guide_ring_01.2018-kr.pdf" width="100%" height="2100px" />
    )
}

export default TwistOutlet11